'use strict';

import { setTimerUI } from "../../../_scripts/helpers";

export default class EventDetailsBanner {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.startTime = $('.event-details-banner__starttime', this.$selector).data('starttime');
    this.targetDate = new Date(this.startTime).getTime();

    if(selfInit) this.init();
  }

  init() {
    setTimerUI(this.$selector, this.targetDate);


    let interval = setInterval(() => {
      setTimerUI(this.$selector, this.targetDate);
    
      // If the count down is finished, write some text
      if ((this.targetDate - new Date().getTime()) < 0) {
        $('.event-details-banner__starttime', this.$selector).hide();
        window.emitter.emit('bannerloaded');
        
        clearInterval(interval);
        $('.day .counter', this.$selector).text('00');
        $('.hour .counter', this.$selector).text('00');
        $('.min .counter', this.$selector).text('00');
        $('.sec .counter', this.$selector).text('00');
      }
    }, 1000);
  }
}
